export const state = {
  fleetGroup: null,
  settings: {
    usingArrow: false,
    isLicensePlateVisible: true,
  },
  loadingSetting: false,
}

export const mutations = {
  SET_FLEET_GROUP(state, value) {
    state.fleetGroup = value
  },

  SET_LOADING_SETTING(state, payload) {
    state.loadingSetting = payload
  },

  SET_ROUTE_SETTING(state, payload) {
    state.settings = { ...state.settings, ...payload }
  },
}

export const actions = {
  setFleetGroup({ commit }, value) {
    commit('SET_FLEET_GROUP', value)
  },

  setRouteSetting({ commit }, payload) {
    commit('SET_ROUTE_SETTING', payload)
  },

  setLoadingSetting({ commit }, payload) {
    commit('SET_LOADING_SETTING', payload)
  },
}

export const getters = {
  getFleetGroup: (state) => state.fleetGroup,
  isLoadingSetting: (state) => state.loadingSetting,
  usingArrow: (state) => state.settings.usingArrow,
  isLicensePlateVisible: (state) => state.settings.isLicensePlateVisible,
}
